import React, { createContext, useContext, useState, useEffect } from 'react';
import { captureUrlParams, getStoredParams } from '@/utils/urlParams';

/**
 * URL 参数 Context
 * 用于在整个应用中共享 URL 参数状态
 */
const UrlParamsContext = createContext({
  params: {},
  isReady: false
});

/**
 * URL 参数 Provider
 * 在应用启动时捕获 URL 参数，并提供给所有子组件
 */
export const UrlParamsProvider = ({ children }) => {
  const [params, setParams] = useState({});
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // 捕获 URL 参数
    const capturedParams = captureUrlParams();
    setParams(capturedParams);
    setIsReady(true);
  }, []);

  return (
    <UrlParamsContext.Provider value={{ params, isReady }}>
      {children}
    </UrlParamsContext.Provider>
  );
};

/**
 * 使用 URL 参数的 Hook
 * @returns {{ params: Object, isReady: boolean }}
 */
export const useUrlParams = () => {
  const context = useContext(UrlParamsContext);
  if (!context) {
    throw new Error('useUrlParams must be used within UrlParamsProvider');
  }
  return context;
};

